import { useCallback } from "react";

import { useFormatTypedValue } from "src/hooks/useFormatTypedValue";
import { Element } from "src/types/element";
import { Identifier } from "src/types/identifier";
import { PropertyValue } from "src/types/property";

import { ComparisonMapping } from "../Widget.typings";

export const useCheckMismatch = () => {
  const formatTypedValue = useFormatTypedValue();

  const checkMismatch = useCallback(
    (
      comparisonMapping: ComparisonMapping | null | undefined,
      elements: Element[],
      foundProperties?: Identifier[] | PropertyValue[],
      propertyCodeToFind?: string | null | undefined,
      foundPropertyOrIdentifier?: Identifier | PropertyValue | undefined
    ): { mismatch: boolean | undefined; comparisonValue: string | undefined } | undefined => {
      if (!comparisonMapping) {
        return undefined;
      }

      let mismatch: boolean | undefined = undefined;
      let value: string | undefined = undefined;

      if (comparisonMapping) {
        const propertiesToCheck = foundProperties
          ? foundProperties // Use the provided array of properties (First Code)
          : [{ code: propertyCodeToFind, value: foundPropertyOrIdentifier?.value }]; // Single property (Second Code)

        propertiesToCheck.forEach((property) => {
          const comparisonEntry = comparisonMapping.properties.find(
            (entry) => entry.caseProperty === property.code
          );

          if (comparisonEntry) {
            const comparisonElement = elements.find(
              (el) => el.configurableType.code === comparisonMapping.elementToCompare
            );

            const comparisonValue = comparisonElement?.properties.find(
              (prop) => prop.property.code === comparisonEntry.papperProperty
            );

            if (comparisonValue && comparisonValue.value !== property.value) {
              mismatch = true;

              value = formatTypedValue(comparisonValue.value);
            }
          }
        });
      }

      return { mismatch, comparisonValue: value };
    },
    [formatTypedValue]
  );

  return checkMismatch;
};
